import Vue, { CreateElement, VNode } from "vue";
import Component from "vue-class-component";
import { Provide, Inject, Watch } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";

@Component({})
export default class GhBase extends Vue {
  protected path: string | undefined = "";
  [key: string]: any;

  @Watch("$route")
  private observeRoute(to: IndexObject, from) {
    if (to.name === this.path) {
      this.onNavigateTo(to.params);
    }
    if (to.meta) {
      this.title = to.meta.title;
    }
  }

  protected onNavigateTo(parames) {}

  protected onNavigateLeave(params) {}

  protected title: string = "";

  // 系统总线
  @Inject()
  sysBus: Vue;

  @Provide()
  viewBus: Vue = new Vue();

  @State(state => state.loginer)
  protected loginer: ILoginer;

  protected navigationArgs: any = null;

  public navigate(name, args?: any, title?: string) {
    this.$router.push({ name, params: args }, r => {
      if (title) {
        r.meta.title = title;
      }
    });
  }

  // @Watch("title")
  // private observeTitle() {
  //   this.$route.meta.title = this.title;
  // }

  created() {
    if (this.title) {
      this.$route.meta.title = this.title;
    }
    this.path = this.$route.name;
  }

  mounted() {
    this.onNavigateTo(this.$route.params);
  }
}
